import { User } from '@microsoft/microsoft-graph-types-beta';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IMeState {
  me?: User;
}

const initialState: IMeState = {
  me: undefined
};

// tslint:disable: no-empty

const meSlice = createSlice({
  initialState,
  name: 'me',
  reducers: {
    setMe: (state, action: PayloadAction<User>) => {
      state.me = action.payload;
    }
  }
});

export const { actions: meActionCreators, reducer: meReducer } = meSlice;
